// @flow

export const isVehicleKeyAncestor = (vehicleKey: ?string, candidateKey: ?string): boolean => {
	if (!vehicleKey || !candidateKey) return false;
	return vehicleKey === candidateKey || vehicleKey.startsWith(candidateKey + "_");
};

/**
 * Walks a vehicle-series tree and returns the deepest node whose key is matched by
 * `matches(node)` together with the full path from the root series down to it.
 * Used to reconstruct the breadcrumb for a selected vehicle even when the leaf
 * vehicle is not present in the currently displayed (filtered) catalog.
 */
export const findDeepestVehiclePath = (seriesList: any[], matches: (any) => boolean): any[] => {
	const walk = (node, pathSoFar) => {
		const path = [...pathSoFar, node];
		let best = matches(node) ? path : null;
		for (const child of node.categories || []) {
			const childBest = walk(child, path);
			if (childBest && (!best || childBest.length > best.length)) {
				best = childBest;
			}
		}
		return best;
	};

	let best = null;
	for (const series of seriesList || []) {
		const match = walk(series, []);
		if (match && (!best || match.length > best.length)) {
			best = match;
		}
	}
	return best || [];
};

/**
 * Walks down from `node` through child branches that have exactly one child,
 * returning the deepest unambiguous descendant. Stops at the first node that
 * has zero or two-or-more children. Used when a user picks a vehicle level in
 * the filter: if the deeper levels carry no additional choice, the filter
 * automatically descends to the most specific node.
 */
export const descendThroughSingleChildren = (node: any): any => {
	let current = node;
	while (current && Array.isArray(current.categories) && current.categories.length === 1) {
		current = current.categories[0];
	}
	return current;
};
